//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>
  <DIV class='content-wrapper'
   v-loading="loadingSpinner"
   element-loading-text="Подождите">

  <div v-if="serverData.loadingDataStatus.mainCommonData != serverData.loadingDataStatus.types.LOADED" class="loading-text">
    Подождите, загружаются общие данные
  </div>
  <div v-else-if="serverData.loadingDataStatus.places != serverData.loadingDataStatus.types.LOADED" class="loading-text">
    Подождите, загружаются данные по площадкам
  </div>
  <div v-else-if="place == null" style="width:100%; float:left">
    <div @click="close()"><i class="fas fa-arrow-circle-left back-button"></i></div>
    <div class="placenotfound-text">Площадка не найдена</div>
  </div>
  <div v-else class="place">

    <div id="placeimage1" class="place-image" :style="{'background-image': 'url(' + serverData.imagesGetURL(place.val.images[0]) + ')'}">
      <i class="fas fa-arrow-circle-left back-button-over" @click="close()"></i>
      <i class="fas fa-edit back-button-over-center" @click="$refs.uploadingFileRef1.click()"></i>
      <input type="file" ref="uploadingFileRef1" @change="uploadingFileOnChange(1)" class="input_file_hidden"/>
    </div>

    <DIV class="place-props-block">                                                                          

    <div style="width:100%; padding:10px 0 0 0; float:left;">
      <div class="place-prop-title">Название</div>
      <Input v-model="place.val.name" placeholder="Название" size="large" class="place-prop"/>
    </div>

    <div style="width:100%; float:left;">
      <div class="place-prop-title">Город</div>
      <Input v-model="place.val.city" placeholder="Город" size="large" class="place-prop"/>
    </div>

    <div style="width:100%; float:left;">
      <div class="place-prop-title">Адрес</div>
      <Input v-model="place.val.address" placeholder="Адрес" size="large" class="place-prop"/>
    </div>

    <div style="width:100%; float:left;">
      <div class="place-prop-title">Описание</div>
      <Input v-model="place.val.description" placeholder="Описание" size="large" type="textarea" :rows="3" class="place-prop"/>
    </div>

    <Button type="primary" size="large" class="button button-primary" style="width:calc((100% - 10px - 4px) / 2); margin:20px 0 0 0"    @click="saveAndClose()">Сохранить</Button>
    <Button type="ghost"   size="large" class="button"                style="width:calc((100% - 10px - 4px) / 2); margin:20px 0 0 10px" @click="close()"       >Отменить</Button>

    </DIV>

  </div>

  </DIV>
</template>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
import { mapGetters } from 'vuex'

import async from 'async'

import serverData from '@/store/serverData'

import http from 'axios'
import restResource from '@/technical/restResource'
import serverErrorHandling from '@/technical/serverErrorHandling'

export default {
  components: { },
  props: ['id'],
  data () {
    return {
      placeId: null,
      place: null,
      uploadingFiles: {1: '', 2: '', 3: '', 4: '', 5: '', 6: ''}, // это не файлы которые пришли с записью из БД, это файлы загруженные пользователем в браузере на замену
      serverData: serverData, // to make access from UI template
      loadingSpinner: false
    }
  },
  computed: {
    ...mapGetters([
      'appSettings',
      'activeUser'
    ])
  },
  created: function () {
    var thisRef = this
    // загружаем данные, когда представление создано и данные реактивно отслеживаются
    this.getPlaceData()
    // подписываемся на загрузку основных данных - когда эта страница это та на которой стартует приложение и на момент created данные еще не подгрузились
    serverData.eventsBus.$on('mainCommonDataLoaded', this.getPlaceData)
    // на realtime обновления places подписываемся на случай если кто-то обновил именно этого места
    serverData.eventsBus.$on('placesChanged', function (data) {
      // вызов этого обработчика будет и пока грузятся основные данные через mainCommonDataLoader что уже обрабатывается
      // через подписку на $on('mainCommonDataLoaded') и второй обработки places нам не надо
      if (data.initiator === 'realtimeServerDataManager') thisRef.getPlaceData(data)
    })
  },
  watch: {
    // при изменениях маршрута запрашиваем данные снова. а если сначала смотрели /event/1, ушли, и снова смотрим но /event/2 то кроме как через watch route больше об этом не узнать
    // !!!!!! И ВАЖНО ПОМНИТЬ: этот роутер будет вызываться вообще всегда даже когда ходишь по эвентам. поэтому проверку надо на router.path иrouter.name
    $route: 'getPlaceData'
  },
  methods: {
    // data - это может быть null если при create
    // может быть объект из realtimeServerDataManager  {method:'update', record:{id, name...}, initiator: "realtimeServerDataManager"}
    // а может быть объект route из watch route.
    // примеры
    //   {name:'place', path:'/place-edit/1', params:{id:1}}
    //   {name:'place-edit-new', path:'/place-edit', params:{}}
    //   {name:'place-edit-new', path:'/place-edit', params:{}}
    // console.log(this.$router.app._route.name)
    getPlaceData (data) {
      // console.log('----------------')
      // console.log('getPlaceEditData')
      // console.log(data)
      // if (data != null) console.log(data.name)
      // if (data != null) console.log(data.path)
      if ((data != null) && (data.path != null) && ((data.name !== 'place-edit') && (data.name !== 'place-edit-new'))) return // на случай если это вызов через watch route когда ушли со страницы и тут так проверяем: если есть data.path значит data это роутер а не дата из realtime и если новый data.name("place", "events" etc) то уже выходим
      if ((data != null) && (data.record != null) && (data.record.id !== this.placeId)) return // другие типы объектов кроме place не придут. и тут на случай если пришло через realtimeServerDataManager обновление но объект с другим id
      if ((this.id != null /* не создание нового места а редактирование */) && (this.isActiveUserAdmin() === false)) { this.$router.push('/pageForbidden'); return }
      if (this.activeUser == null) { this.$router.push('/pageForbidden'); return } // незалогинных долой
      // console.log('getPlaceEditData processing')
      this.placeId = this.id
      if (this.placeId != null) {
        if (typeof this.placeId === 'string') this.placeId = parseInt(this.placeId)
        var anPlace = serverData.placesMap[this.placeId]
        if (anPlace == null) { /* console.log('PlaceEdit.getPlaceData: common data not loaded. exit'); */ return } // это происходит при перезагрузки страницы, данные еще не пришли с сервера
        this.place = Object.assign({}, anPlace)
        this.place.val = Object.assign({}, anPlace.val)
        // this.place.val.images = Object.assign({}, anPlace.val.images)
      } else {
        this.place = restResource(this.appSettings.server.placeResource)
        this.place.val = {
          name: '',
          city: 'Нижний Новгород',
          address: '',
          description: '',
          images: []
        }
      }
      // console.log('getPlaceEditData end')
    },
    isActiveUserAdmin () {
      if ((this.activeUser != null) && ((this.activeUser.group === 0) || (this.activeUser.group === 1))) return true // суперпользователь или админ
      return false
    },
    close () {
      if ((this.$router.app._route.name !== 'place-edit') && (this.$router.app._route.name !== 'place-edit-new')) return // это значит что уже перешли куда-то типа place-edit и это close лишнее с обработки картинки а не иконки назад и history.back делать не надо
      // 2 - это значит пустая страница + текущая с продуктом. или 1 - сразу из внешнего приложения открылась эта страница
      if (history.length <= 2) window.location.href = '/' // !!! проверить
      else history.back() // this.$router.go(-1)
    },
    uploadingFileOnChange (fileIndx, file) {
      // забираем себе объект готового к загрузке файла
      if (file != null) this.uploadingFiles[fileIndx] = file
      else this.uploadingFiles[fileIndx] = this.$refs['uploadingFileRef' + fileIndx].files[0]

      if (this.uploadingFiles[fileIndx]) {
        // меняем картинку редактируемого fileEntity
        var reader = new FileReader()
        reader.onload = function (e) {
          var el = document.getElementById('placeimage' + fileIndx)
          el.style.backgroundImage = 'url(' + e.target.result + ')'
        }
        reader.readAsDataURL(this.uploadingFiles[fileIndx])
      }
    },
    saveImage (fileIndx, cb) {
      if (this.uploadingFiles[fileIndx] === '') return cb()
      let formData = new FormData()
      if (this.place.val.images[fileIndx - 1] != null) formData.append('id', this.place.val.images[fileIndx - 1]) // если заменяем файл, то вносим fileEntity id
      formData.append('name', this.uploadingFiles[fileIndx].name.trim()) // !!! еще укоротить название? - защита от хакеров?
      formData.append('container', 'places')
      formData.append('_data', this.uploadingFiles[fileIndx])

      http.post(this.appSettings.server.fileEntityResource + '/storeFileByFormData/', formData, {headers: {'Content-Type': 'multipart/form-data'}})
      .then(function (response) {
        return cb(null, response) // здесь из data берем fileEntity и из нее id для обновления данных images в записи product
      })
      .catch(function (err) { return cb(err) })
    },
    saveAndClose () {
      if ((this.placeId == null) && (this.uploadingFiles[1] === '')) return this.$message.error('Загрузите картинку площадки') // для новых создаваемых - нельзя без картинки
      if (this.place.val.name.length < 6) return this.$message.error('Слишком короткое название')
      if (this.place.val.city.length < 7) return this.$message.error('Слишком короткое название города')
      if (this.place.val.address.length < 7) return this.$message.error('Слишком короткий адрес')

      this.place.val.updatedBy = this.activeUser.id

      var thisRef = this

      thisRef.loadingSpinner = true
      const loading = thisRef.$loading({
        lock: true,
        text: 'Подождите, идет сохранение данных'
      })

      async.parallel({
        file1: function (asyncCallback) {
          thisRef.saveImage(1, function (err, response) {
            if ((err == null) && (response != null)) thisRef.place.val.images[0] = response.data.id
            asyncCallback(err)
          })
        },
        file2: function (asyncCallback) {
          thisRef.saveImage(2, function (err, response) {
            if ((err == null) && (response != null)) thisRef.place.val.images[1] = response.data.id
            asyncCallback(err)
          })
        },
        file3: function (asyncCallback) {
          thisRef.saveImage(3, function (err, response) {
            if ((err == null) && (response != null)) thisRef.place.val.images[2] = response.data.id
            asyncCallback(err)
          })
        },
        file4: function (asyncCallback) {
          thisRef.saveImage(4, function (err, response) {
            if ((err == null) && (response != null)) thisRef.place.val.images[3] = response.data.id
            asyncCallback(err)
          })
        },
        file5: function (asyncCallback) {
          thisRef.saveImage(5, function (err, response) {
            if ((err == null) && (response != null)) thisRef.place.val.images[4] = response.data.id
            asyncCallback(err)
          })
        },
        file6: function (asyncCallback) {
          thisRef.saveImage(6, function (err, response) {
            if ((err == null) && (response != null)) thisRef.place.val.images[5] = response.data.id
            asyncCallback(err)
          })
        }
      }, function (error) {
        if (!error) {
          thisRef.place.save()
          .then(function () {
            thisRef.loadingSpinner = false
            loading.close()

            // thisRef.place = null
            thisRef.uploadingFiles = {1: '', 2: '', 3: '', 4: '', 5: '', 6: ''}

            // thisRef.$message.success('Сохранено')
            thisRef.close()
          })
          .catch(function (err) {
            thisRef.loadingSpinner = false
            loading.close()
            serverErrorHandling(err, thisRef)
          })
        } else {
          thisRef.loadingSpinner = false
          loading.close()
          if ((error.response != null) && (error.response.data != null) && (error.response.data.code === 1101)) thisRef.$message.error('Слишком большой размер файла')
          else serverErrorHandling(error, thisRef)
        }
      })
    }
  }
}
</script>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style scoped>
.content-wrapper{
  width: 100%;
  margin: 0px 0px 0px 0px;
  padding: 0px;
  font-family: "Open Sans", sans-serif;
  font-weight: 100;
}
.back-button {
  width: 100%;
  font-size: 35px;
  color: #777;
  padding: 10px 10px 10px 15px;
  cursor: pointer;
  float: left;
}
.back-button-over {
  width: 50px;
  position: relative;
  top: 5px;
  left: 7px;
  font-size: 35px;
  /* color: #888; */
  color: #fff;
  text-shadow: -1px 0 #777, 0 1px #777, 1px 0 #777, 0 -1px #777;
  cursor: pointer;
  float: left;
}
.back-button-over-center {
  width: 50px;
  position: relative;
  top: calc(100vw - 100px);
  left: calc((100vw / 2) - 63px);
  font-size: 35px;
  /* color: #888; */
  color: #fff;
  text-shadow: -1px 0 #777, 0 1px #777, 1px 0 #777, 0 -1px #777;
  cursor: pointer;
  float: left;
}
@media screen and (min-width: 450px) {
  .back-button-over-center {
    top: 350px;
    left: 162px;
  }
}
.loading-text {
  font-family: "Open Sans", sans-serif;
  font-weight: 100;
  font-size: 20px;
  padding: 20px 20px 20px 20px;
}
.placenotfound-text {
  font-family: "Open Sans", sans-serif;
  font-weight: 300;
  font-size: 20px;
  padding: 20px 20px 20px 20px;
}
.place {
  width: 100%;
  margin-left: 0%;
  padding-bottom: 40px;
  text-align: left;
  float:left;
}
.place-image {
  width: 100%;
  height: 100vw;
  background: #333;
  background-size: cover;
  background-position: center;
  border-radius: 20px 20px 0 0;
  border-bottom: solid 1px #e0e0e0;
  cursor: default;
  float: left;
}
@media screen and (min-width: 450px) {
  .place {
    width: 450px;
    margin-left: calc((100% - 450px) / 2);
  }
  .place-image {
    width: 450px;
    height: 450px;
    border-radius: 20px;
    border: solid 1px #e0e0e0;
  }
}
.place-props-block {
  width: 100%;
  padding: 0 25px 0 25px;
}
.place-prop-title {
  width: 130px;
  padding: 15px 0px 0px 0px;
  color: #666;
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  font-size: 17px;
  float:left;
}
.place-prop {
  width: calc(100% - 130px);
  padding: 7px 0px 0px 0px;
  color: #666;
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  font-size: 17px;
  float:left;
}
.text-align-left {
  text-align:left;
}
.text-align-right {
  text-align:right;
}
.button{
  border-radius: 15px;
  font-size: 16px;
}
.button-primary{
  /*background: #6770a6;*/
  background: #6070dd;
}
.input_file_hidden{
  position: absolute;
  top: -500px;
}
</style>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// PlaceEdit.vue?0eb5fad9